import { render, staticRenderFns } from "./Conf01View.vue?vue&type=template&id=12d32621&scoped=true&"
import script from "./Conf01View.vue?vue&type=script&lang=ts&"
export * from "./Conf01View.vue?vue&type=script&lang=ts&"
import style0 from "./Conf01View.vue?vue&type=style&index=0&id=12d32621&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d32621",
  null
  
)

export default component.exports